import { useTranslation } from 'react-i18next';

import { Chip } from 'common/components/Chip';
import { ITrainingRole } from 'graphql/types';
import { getVisibleTrainingRoles } from 'training/utils/trainingRoles';

interface IProps {
    roles?: ITrainingRole[] | null;
    // Roles to suppress even when present
    hiddenRoles?: ITrainingRole[];
}

export const TrainingRoleChips = ({ roles, hiddenRoles }: IProps) => {
    const [translate] = useTranslation();

    const visibleRoles = getVisibleTrainingRoles(roles, hiddenRoles);

    if (!visibleRoles.length) return null;

    return (
        <>
            {visibleRoles.map(({ role, labelKey }) => (
                <Chip
                    bgColor="secondary"
                    key={role}
                    label={translate(labelKey)}
                />
            ))}
        </>
    );
};
